import * as Rx from 'rxjs';
import * as RxOp from 'rxjs/operators';
import { EMPTY_ACTION } from '.';
import { LOGIN_SUCCESS } from '../pages/login/Login.state';
import { TERMINAL_LOGIN_SUCCESS } from '../pages/terminal-login/TerminalLogin.state';

export const locallyStoreSessionsEpic = (action$, state$) =>
  action$.pipe(
    RxOp.filter((action) =>
      [LOGIN_SUCCESS, TERMINAL_LOGIN_SUCCESS].includes(action.type),
    ),
    RxOp.flatMap(() => {
      const serializedTerminalSession = JSON.stringify(
        state$.value.terminalLogin,
      );
      const serializedSession = JSON.stringify(state$.value.login);
      localStorage.setItem('terminalSession', serializedTerminalSession);
      localStorage.setItem('session', serializedSession);

      return Rx.of(EMPTY_ACTION);
    }),
  );
